import { BoxProps, ColorOptions, TextNewProps } from '@jfs/ui-new'

export const style = (isExpanded: boolean, isLastIndex: boolean, isFirstIndex: boolean, isMobile: boolean) => ({
  accordionView: {
    borderTopWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: isLastIndex ? 1 : 0,
    padding: isMobile ? 16 : 24,
    borderBottomLeftRadius: isLastIndex ? 8 : 0,
    borderBottomRightRadius: isLastIndex ? 8 : 0,
    borderTopLeftRadius: isFirstIndex ? 8 : 0,
    borderTopRightRadius: isFirstIndex ? 8 : 0,
    bg: isExpanded ? 'LIGHT_GREY_SEPARATOR' : 'WHITE',
    borderColor: 'LIGHTEST_GREY',
    underlayColor: 'LIGHTEST_GREY',
  } as BoxProps,
  titleText: {
    fontFamily: isExpanded ? 'jiotype-bold' : 'jiotype-medium',
    color: isExpanded ? 'BLACK' : 'BLACK_21',
    fontWeight: isExpanded ? '900' : '400',
    fontSize: isMobile ? 14 : 16,
    lineHeight: isMobile ? 20 : 24,
  } as TextNewProps,
  subtitleContainer: {
    pt: 5,
    flexDirection: 'row',
  } as BoxProps,
  subtitle: {
    fontFamily: 'jiotype-medium',
    color: 'PRIMARY_GREY',
    fontWeight: '400',
    fontSize: isMobile ? 12 : 14,
    lineHeight: 20,
  } as TextNewProps,
  roundBulletin: {
    h: 6,
    w: 6,
    alignSelf: 'center',
    borderRadius: 4,
    bg: 'DARK_GREY',
    opacity: 0.8,
  } as BoxProps,
  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  } as BoxProps,
  emailPhone: {
    fontFamily: 'jiotype-medium',
    fontWeight: '400',
    fontSize: isMobile ? 12 : 14,
    lineHeight: 20,
    color: '#0070B6' as ColorOptions,
  } as TextNewProps,
})
